// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

const selectChecked = "absolute w-1/2 h-0.5 mx-auto bg-white";

function containerRules(whiteMode, disabled, subText) {
  return Cn.fromList({
    hd: "select-none flex",
    tl: {
      hd: Belt__Belt_Option.isSome(subText) ? "items-start" : "items-center",
      tl: {
        hd: disabled ? "cursor-not-allowed" : "cursor-pointer",
        tl: {
          hd: Cn.on("text-white", whiteMode),
          tl: /* [] */ 0
        }
      }
    }
  });
}

function indicatorRules(isChecked, hasError, whiteMode, disabled, text, subText) {
  return Cn.fromList({
    hd: "relative w-4 h-4 rounded-3px border bg-no-repeat bg-center flex items-center justify-center",
    tl: {
      hd: Belt__Belt_Option.isSome(text) ? "mr-2" : "mr-0",
      tl: {
        hd: Belt__Belt_Option.isSome(subText) ? "mt-0.5" : "mt-0",
        tl: {
          hd: Cn.on("bg-alert border-alert", hasError),
          tl: {
            hd: Cn.on("bg-gray-pale", !whiteMode && disabled),
            tl: {
              hd: Cn.on("border-default-gray", !isChecked && !hasError && !disabled),
              tl: {
                hd: Cn.on("border-gray-main", disabled),
                tl: {
                  hd: Cn.on("bg-white border-white", isChecked && whiteMode),
                  tl: {
                    hd: Cn.on("bg-links border-links", isChecked && !whiteMode),
                    tl: /* [] */ 0
                  }
                }
              }
            }
          }
        }
      }
    }
  });
}

const Styles = {
  selectChecked: selectChecked,
  containerRules: containerRules,
  indicatorRules: indicatorRules
};

function Checkbox(Props) {
  let isCheckedOpt = Props.isChecked;
  let whiteModeOpt = Props.whiteMode;
  let onChangeOpt = Props.onChange;
  let selectModeOpt = Props.selectMode;
  let text = Props.text;
  let value = Props.value;
  let subText = Props.subText;
  let tabIndex = Props.tabIndex;
  let name = Props.name;
  let disabledOpt = Props.disabled;
  let hasErrorOpt = Props.hasError;
  let className = Props.className;
  const isChecked = isCheckedOpt !== undefined ? isCheckedOpt : false;
  const whiteMode = whiteModeOpt !== undefined ? whiteModeOpt : false;
  const onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
      
    });
  const selectMode = selectModeOpt !== undefined ? selectModeOpt : false;
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const hasError = hasErrorOpt !== undefined ? hasErrorOpt : false;
  let tmp = {
    hidden: true,
    checked: isChecked,
    disabled: disabled,
    type: "checkbox",
    value: Belt__Belt_Option.mapWithDefault(value, isChecked ? "1" : "0", (function (value) {
      return value;
    })),
    onChange: (function (ev) {
      Curry._1(onChange, ev.target.checked);
    }),
    onClick: (function (ev) {
      ev.stopPropagation();
    })
  };
  if (tabIndex !== undefined) {
    tmp.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  if (name !== undefined) {
    tmp.name = Caml_option.valFromOption(name);
  }
  return JsxRuntime.jsxs("label", {
    children: [
      JsxRuntime.jsx("div", {
        children: isChecked ? (
            selectMode ? JsxRuntime.jsx("div", {
                className: selectChecked
              }) : JsxRuntime.jsx("svg", {
                children: JsxRuntime.jsx("path", {
                  d: "M2 6.41579L5.30838 9L10 3",
                  stroke: whiteMode ? "#424E59" : "#fff",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }),
                height: "12",
                width: "12",
                fill: "none",
                viewBox: "0 0 12 12",
                xmlns: "http://www.w3.org/2000/svg"
              })
          ) : null,
        className: indicatorRules(isChecked, hasError, whiteMode, disabled, text, subText)
      }),
      JsxRuntime.jsx("input", tmp),
      text !== undefined ? JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
          nowrap: true,
          className: Cn.fromList({
            hd: "flex flex-col",
            tl: {
              hd: whiteMode ? "text-white" : "text-black",
              tl: /* [] */ 0
            }
          }),
          children: [
            text,
            subText !== undefined ? JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                className: "text-gray-medium",
                children: subText
              }) : null
          ]
        }) : null
    ],
    className: Cn.fromList({
      hd: containerRules(whiteMode, disabled, subText),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    })
  });
}

const make = Checkbox;

export {
  Styles,
  make,
}
/* Buhta_components__Text Not a pure module */
